import Page from "webPage/Page";
import ScrollMagic from "scrollmagic";
import {TimelineMax, TweenMax} from "gsap";
import {registerScene, sectionGetHeight} from "util/parallax";

Page.register('post-type-archive-solutions', () => {

    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-breadcrumb',
    //     duration: sectionGetHeight('.js-parallax-breadcrumb'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     //TweenMax.fromTo('.js-breadcrumb-circle-1', 1, {yPercent: 10}, {yPercent: -10}),
    //     //TweenMax.fromTo('.js-breadcrumb-circle-2', 1, {yPercent: 10}, {yPercent: -10}),
    // ])));
});